<template>
  <div class="setting" v-loading="loading">
     <div id="userinfo">
      <img class="avatar" :src="userInfo.avatar" />
      <div class="info-container">
        <div class="name">
          <p class="nickname">
            <span>{{ developerInfo.nickname }}</span>
            <span class="level_desc" v-if="developerInfo.level_desc">{{ developerInfo.level_desc }}</span>
            <span class="noviciate" v-if="developerInfo.dev_state === 2">{{$vi18n('$i18n# 见习开发者 #i18n$')}} <img class="flag" src="@/assets/images/noviciate-flag.png" alt="flag"></span>
          </p>
        </div>
        <!-- <div class="name" v-else>
          <p class="nickname">{{ developerInfo.nickname }}</p>
          <template v-if="developerInfo.state !== undefined">
            <a
              class="txt bg-normal"
              v-if="developerInfo.state == 0 || developerInfo.state == 3"
              href="https://dev-wiki.mini1.cn/cyclopdeia?wikiMenuId=1634&wikiId=805"
              target="_blank"
              @click="becomeDeveloper"
              >{{$vi18n('$i18n# 成为创作者 #i18n$')}}</a
            >
            <span class="txt bg-developer" v-else>
              {{$vi18n('$i18n# 创作者 #i18n$')}}Lv {{ developerInfo.level }}</span
            >
          </template>
        </div> -->
        <div class="account">
          <span>{{$vi18n('$i18n# 迷你号 #i18n$')}}：{{ userInfo.uin }}</span>
          <span>{{$vi18n('$i18n# 作品 #i18n$')}}：{{ developerInfo.product }}</span>
          <span>{{$vi18n('$i18n# 关注 #i18n$')}}：{{ developerInfo.follow }}</span>
          <span>{{$vi18n('$i18n# 粉丝 #i18n$')}}：{{ developerInfo.fans }}</span>
        </div>
      </div>
    </div>
    <div class="title">{{$vi18n('$i18n# 账号设置 #i18n$')}}</div>
    
    <div class="main">
      <el-form ref="form" :model="form" label-width="120px" style="width:800px">
        <el-form-item
          :label="$vi18n('$i18n# 名 #i18n$')">
          <el-input
            v-model="form.name"
            style="width:270px;"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$vi18n('$i18n# 中间名 #i18n$')">
          <el-input
            v-model="form.middle_name"
            style="width:270px;"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$vi18n('$i18n# 姓 #i18n$')">
          <el-input
            v-model="form.last_name"
            style="width:270px;"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$vi18n('$i18n# 邮箱 #i18n$')">
          <el-input
            :value="form.email"
            style="width:360px;"
            :disabled="true"
          ></el-input>
          <el-button style="margin-left: 20px;" type="text" @click="modify">{{$vi18n('$i18n# 修改 #i18n$')}}</el-button>
        </el-form-item>
        <!-- 只有在测试环境才会有绑定uin的操作 -->
        <!-- <el-form-item label="绑定uin" v-if="!isProd">
          <el-input
            v-model="bindUin"
            style="width:360px;"
          ></el-input>
          <el-button style="margin-left: 20px;" type="text" @click="changeBindUin">修改</el-button>
        </el-form-item> -->
      </el-form>
      <NoviciateMask v-if="isNoviciateDeveloper" :height="500"></NoviciateMask>
    </div>
  </div>
</template>

<script lang="js">
import { mapState } from 'vuex';
import { getServeUin } from '@/utils/index.js';
import { bindUin } from '@/api/account.js';
import { getKfzInfo } from '@/api/common.js'
import NoviciateMask from '@/components/NoviciateMask'
export default {
  name: 'setting',
  components: {
    NoviciateMask
  },
	data() {
		return {
			isProd: process.env.VUE_APP_REALEASE === 'released',
			form: {
				name: '',
				email: '',
				middle_name: '',
				last_name: ''
			},
			bindUin: '',
			loading: false
		};
	},
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
    isNoviciateDeveloper() {
      return this.developerInfo.dev_state === 2
    },
  },
	methods: {
		async getAccountHandler() {
			try {
				this.loading = true;
				const res = await getKfzInfo({
					uin: sessionStorage.getItem('uin')
				});
        const data = res.data || {}
				this.form.name = data.name;
				this.form.email = data.email;
				this.form.last_name = data.last_name;
				this.form.middle_name = data.middle_name;
				this.bindUin = data.bind_uin;
			} catch (error) {
				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		modify() {
			this.$router.push({
				path: '/account/editemail'
			});
		},
		async changeBindUin() {
			if (this.isProd) {
				console.log(this.$vi18n('$i18n# 非测试环境,不能绑定uin #i18n$'));
			}
			if (!this.bindUin) {
				this.bindUin = '0';
			}
			const data = await bindUin({
				uin: sessionStorage.getItem('uin'),
				bind_uin: this.bindUin === '0' ? this.bindUin : getServeUin(this.bindUin),
			});
			if (data.code === 0) {
				this.$message.success(data.msg);
			}
			this.getAccountHandler();
		}
	},
	created() {
		this.getAccountHandler();
	}
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.content-wrapper {
  padding: 0;
}
.setting {
  position: relative;
  width: 976px;
  margin: auto;

  .title {
    width: 976px;
    height: 60px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    font-size: 24px;
    font-weight: 400;
    line-height: 60px;
    padding: 0 35px;
    color: rgba(38, 38, 38, 1);
  }

  .main {
    min-height: 860px;
    width: 976px;
    position: relative;
    .noviciate-mask {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100% !important;
      background: rgba(255, 255, 255, 0.92);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      .icon {
        width: 150px;
        margin-top: 100px;
      }
      .head {
        font-size: 30px;
        color: #595959;
        margin-top: 100px;
      }
      .desc {
        font-size: 18px;
        color: #6e6969;
        margin-top: 50px;
      }
      .btn {
        margin-top: 100px;
      }
    }
  }

  .modify {
    position: absolute;
    width: 90px;
    height: 50px;
    text-align: right;
    left: 570px;
    top: 235px;

    div {
      font-size: 16px;
      text-align: center;

      a {
        text-decoration: none;
        color: rgba(80, 163, 241, 1);
      }
    }

    h6 {
      font-size: 14px;
      color: rgba(140, 140, 140, 1);
    }
  }

  .untied {
    position: absolute;
    width: 130px;
    height: 50px;
    text-align: right;
    left: 570px;
    top: 300px;

    div {
      color: rgba(80, 163, 241, 1) !important;
      font-size: 16px;

      a {
        text-decoration: none;
        color: rgba(80, 163, 241, 1) !important;
      }
    }

    h6 {
      font-size: 14px;
      color: rgba(140, 140, 140, 1);
    }
  }
}

.el-form {
  margin: auto;
  margin-top: 40px;
}
#userinfo {
  display: flex;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  border-bottom: 10px solid #f5f5f5;
  .avatar {
    width: 100px;
    height: 100px;
    background: #eee;
    border-radius: 50%;
    margin-right: 40px;
  }
  .account-click {
    font-size: 14px;
    line-height: 17px;
    color: #8c8c8c;
    text-decoration: underline;
    cursor: pointer;
    opacity: 1;
  }
  .info-container {
    display: flex;
    flex-flow: column;
    justify-content: space-around;
    flex: 1;
    .name {
      display: flex;
      align-items: center;
      .nickname {
        font-size: 16px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        .noviciate {
          margin-left: 20px;
          display: flex;
          align-items: center;
          color: #fd9b21;
          .flag {
            width: 20px;
          }
        }
      }
      .txt {
        height: 36px;
        text-align: center;
        line-height: 36px;
        border-radius: 18px;
        font-size: 16px;
        color: #fff;
        padding: 0 20px;
      }
      a {
        text-decoration: none;
      }
      .bg-normal {
        background-color: $--color-primary;
        cursor: pointer;
        &:hover {
          filter: brightness(110%);
        }
      }
      .bg-developer {
        background-color: #253b51;
      }
      .bg-thValue {
        .desc {
          margin-right: 2px;
        }
        margin: 0 10px;
        margin-top: 4px;
        font-size: 16px;
      }
    }
    .name-wrap {
      .nickname {
        line-height: 19px;
        color: #262626;
        opacity: 1;
        font-size: 16px;
        margin-bottom: 10px;
      }
      .rights {
        display: flex;
        .account.bg-developer,
        .account.bg-normal {
          display: inline;
          height: 22px;
          background: #3cacf6;
          opacity: 1;
          border-radius: 11px;
          font-weight: 400;
          line-height: 19px;
          color: #ffffff;
          font-size: 12px;
          padding: 2px 6px 3px;
        }
        .value-wrap {
          font-size: 12px;
          margin-top: -2px;
          margin-left: 12px;
          .bg-thValue {
            color: #8c8c8c;
          }
          .desc {
            margin-right: 6px;
          }
          .number {
            color: #3cacf6ff;
          }
        }
        .progress {
          width: 100%;
          display: flex;
          .complete-progress {
            height: 6px;
            background: linear-gradient(90deg, #3c87ff 0%, #43ffff 100%);
            opacity: 1;
            border-radius: 18px;
            margin-top: -1px;
          }
          .other-progress {
            height: 4px;
            background: #34a9fdff;
            opacity: 0.2;
            margin-left: -2px;
            margin-top: 0.4px;
            border-radius: 18px;
          }
        }
      }
    }
    .account {
      display: flex;
      align-items: center;
      font-size: 14px;

      span {
        padding: 0 40px;
        border-right: 1px solid #d9d9d9;
      }
      span:nth-child(1) {
        padding-left: 0;
      }
      span:nth-child(4) {
        border-right: none;
        padding-right: 0;
      }
      .fans-rise {
        border: 1px solid #ffc973;
        padding: 0 15px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        background: #fffaed;
        margin-left: 19px;
      }
    }
    .account_detail {
      display: flex;
      & > div {
        margin-right: 50px;
      }
      a {
        margin-right: 10px;
      }
      span {
        color: #bb9a9a;
      }
    }
  }
}
.level_desc {
  margin-left: 10px;
  padding: 4px 16px;
  border-radius: 10px;
  background-color: #3cacf6;
  color: #fff;
}

</style>
